<div class="form-error">
  <mat-icon class="error-icon" [svgIcon]="'error'"></mat-icon>
  <div class="form-error-text">{{ displayErrorMessage() }}</div>
</div>
